import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/bits";
import { ReportsPanel } from "./group/Tabs";

export default function Reports() {
  const [groups, setGroups] = useState([]);
  useEffect(() => { api.get("/groups").then((r) => setGroups(r.data)); }, []);
  return (
    <div data-testid="reports-page">
      <PageHeader title="Reports" subtitle="Contribution, outstanding, statement, transaction, savings, payout and special contribution reports." />
      <ReportsPanel groups={groups} />
    </div>
  );
}
